export default "__VITE_ASSET__9d6dcc39__"